if (!customElements.get('personalization-pop-up')) {
  class PersonalizationPopup extends HTMLElement {
    constructor() {
      super();
      this.addtocartbtn = this.querySelector('.product-info__add-button>.btn');
      const modal_id=this.dataset.modalId;
      var modal = document.getElementById(modal_id);
      this.closebtn = modal.querySelector('.modal-content>.close');
      this.bindEvents();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.documentClickHandler);
      document.querySelectorAll('.js-quick-add').forEach((button) => {
        button.removeEventListener('mouseenter', this.quickAddButtonMouseEnterHandler);
      });
      if (this.observer) this.observer.disconnect();
    }
    bindEvents() {
        this.addtocartbtn.addEventListener('click', this.handleAddtocartbtnClick.bind(this));
        this.closebtn.addEventListener('click', this.close.bind(this));
      }
    /**
     * Handles 'click' events on the document.
     * @param {object} evt - Event object.
     */
    handleAddtocartbtnClick(evt) {
      const modal_id=this.dataset.modalId;
      const section_id=this.dataset.sectionId;
      var modal = document.getElementById(modal_id);
      if(modal){
        if(!this.modal_parent)
          this.modal_parent=modal.parentElement;
        modal.style.display = "block";
        document.getElementById("quantity").value=document.getElementById("quantity-"+section_id).value;
        if(document.getElementById("main-content")){
            const main_content= document.getElementById("main-content");
            main_content.style.position="";

            main_content.style.zIndex =30;
            const elements = main_content.getElementsByClassName('container');
            if(modal.parentElement.getBoundingClientRect().width<400 )
            {
              if(elements.length>1)
                elements[1].appendChild(modal);
              else
                elements[0].appendChild(modal);
            }
            else
            {
                modal.style.zInex=50;
            }
            if(elements.length>1 && modal.parentElement!=elements[1])
            {
                main_content.style.position="relative";
            }
        }
      }
    }

    /**
     * Closes the cart drawer.
     */
    close() {
      const modal_id=this.dataset.modalId;
      var modal = document.getElementById(modal_id);
      modal.style.display = "none";
      if(this.modal_parent)
        this.modal_parent.appendChild(modal);
      if(document.getElementById("main-content")){
        document.getElementById("main-content").style.zIndex =0;
      }
    }
  }

  customElements.define('personalization-pop-up', PersonalizationPopup);
}
